'use client'

import { useEffect, useState } from 'react'

import { generateTraceId, toReferenceCode } from '@repo/observability'
import { clientLogger } from '@repo/observability/client'
import { SectionFallback } from '@repo/observability/react'

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const [traceId] = useState(() => generateTraceId())

  useEffect(() => {
    void clientLogger.error(error, {
      traceId,
      handled: true,
      userImpact: 'blocked',
      componentName: 'RouteError',
      action: 'routeBoundary',
      metadata: { digest: error.digest },
    })
  }, [error, traceId])

  return (
    <SectionFallback
      featureName="this page"
      referenceCode={toReferenceCode(traceId)}
      onRetry={reset}
    />
  )
}
